// angular
// 	.module("HeroPRO")
// 	.factory("NotificationCenterFactory", notificationCenterFactory);

import _ from 'lodash';

/* @ngInject */
export default function notificationCenterFactory($http, $q, moment, HPConfig, HPActionItemStatuses, HPActionItemCategories, HPNotifications) {
    let _notifications = [];
    let _activeNotification = null;

    return {
        getNotifications,
        getNotificationData,
        markNotificationComplete,
        getActiveNotification,
        setActiveNotification,
        isLastActiveNotification,
        setNextNotificationAsActive,
        setActionItemStatus
    };

    function getNotifications() {
        // Pass in contractorId to include action items based on contractorId
        const params = {
            actionItemStatuses: HPActionItemStatuses.Open,
            actionItemCategories: [HPActionItemCategories.Compliance, HPActionItemCategories.Setup],
        };

        return $http.get(`${HPConfig.heroProApi}ActionItem/GetActionItems`, { params }).then(response => processNotifications(response.data.Data || []));
    }

    function processNotifications(notifications) {
        _notifications = [];
        return $q((resolve) => {
            _.each(notifications, (notification) => {
                if (notification.PriorityOrder === undefined) {
                    notification.PriorityOrder = 1;
                }
            });

            // We want to sort by Priority first, then by PriorityOrder.
            // To do this using underscore, we use least significant -> most significant
            const sortedNotifications = _.sortBy((_.sortBy(notifications, 'PriorityOrder')), 'Priority');

            _.each(sortedNotifications, (notification, index) => {
                const config = findConfig(notification);

                _notifications.push(_.extend(
                    notification,
                    {
                        Message: notification.CallToActionText,
                        isComplete: false,
                        isActive: index === 0,
                        template: (config) ? config.template : '',
                        menuText: (config) ? config.menuText : '',
                        showModal: angular.isDefined(config) ? config.showModal || false : false,
                    },
                ));

                if (index === 0) {
                    _activeNotification = notification;
                }
            });

            const index = _.findIndex(_notifications, notification => notification.ActionItemTypeId === HPNotifications.DelayedMandatoryTraining.actionItemTypeId);

            if (index > -1) {
                $http.post(`${HPConfig.heroProApi}Contractor/UpdateTrainingDueDate`, { data: { DueDate: _notifications[index].DueDate } }).then((response) => {
                    const data = response.data.Data;
                    if (data.DueDate) {
                        _notifications[index].DaysDueCount = data.DaysDueCount;

                        if (_notifications[index].DaysDueCount < 0) {
                            _notifications[index].showModal = true;
                            _notifications[index].CanBeDismissedByUser = false;
                        }
                    }
                    resolve(_notifications);
                });
            } else {
                resolve(_notifications);
            }
        });
    }

    function getNotificationData() {
        return _.filter(_notifications, notification => notification.isComplete === false) || [];
    }

    function markNotificationComplete(id) {
        const completedNotification = _.filter(_notifications, notification => notification.ActionItemId === id);
        completedNotification[0].isComplete = true;
        return _notifications;
    }

    function getActiveNotification() {
        return _activeNotification;
    }

    function setActiveNotification(notification) {
        _activeNotification = notification;
    }

    function setNextNotificationAsActive() {
        const currentIndex = _.findIndex(_notifications, notification => notification.ActionItemId === _activeNotification.ActionItemId);

        _notifications[currentIndex].isActive = false;
        setActiveNotification(_notifications[currentIndex + 1]);
        _notifications[currentIndex + 1].isActive = true;
    }

    function isLastActiveNotification() {
        return _activeNotification.ActionItemId === _.last(_notifications).ActionItemId;
    }

    function findConfig(notification) {
        return _.find(HPNotifications, notificationConfig => notificationConfig.actionItemTypeId === notification.ActionItemTypeId);
    }

    function setActionItemStatus(params) {
        return $http({
            url: `${HPConfig.heroProApi}ActionItem/UpdateStatus`,
            method: 'POST',
            data: params,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/notificationFactory.js